import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import React from 'react'
import { useCMSPageField } from '@/cms/fields/hooks'
import { useIntl } from '@/intl'
import getUserRatingLabelIntlId from '@/scopes/common/components/utils/getUserRatingLabelIntlId'
import styles from './ReviewsSummary.module.css'

export default function ReviewsSummary({ isHeroSection = false, reviewsAmount }: { isHeroSection?: boolean, reviewsAmount: number }) {
  const intl = useIntl()
  const ratingAverage = useCMSPageField('userReviews.ratingAverage')

  if (!ratingAverage)
    return null

  return (
    <div className={styles.wrapper}>
      <div>
        <Typography as="div" className={cn(styles.ratingBadge, isHeroSection && styles.ratingBadgeHero)}>
          {ratingAverage}
        </Typography>
      </div>
      <div className={styles.headerRightSection}>
        <Typography as="div" className={cn(styles.ratingLabel, isHeroSection && styles.ratingLabelHero)}>
          {intl.formatMessage({ id: getUserRatingLabelIntlId(ratingAverage) })}
          <Sheet.Root>
            <Sheet.Trigger>
              <button className={styles.infoButton} aria-label={intl.formatMessage({ id: 'reviews_legal_information' })}>
                <Icon glyph="InformationInCircle" size={16} />
              </button>
            </Sheet.Trigger>
            <Sheet.Body side="right">
              <Sheet.Header closeLabel={intl.formatMessage({ id: 'close' })} titleLabel={intl.formatMessage({ id: 'reviews_legal_disclaimer_title' })} />
              <Sheet.Content>
                {/* eslint-disable-next-line react-dom/no-dangerously-set-innerhtml -- Content comes from translation and is controlled */}
                <Typography><div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'reviews_legal_disclaimer_html' }) }} /></Typography>
              </Sheet.Content>
            </Sheet.Body>
          </Sheet.Root>
        </Typography>
        <Typography className={styles.numberOfReviewsText}>
          {intl.formatMessage({ id: 'reviews_score_amount_label' }, { amount: reviewsAmount })}
        </Typography>
      </div>
    </div>
  )
}
